'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { filter } from 'rxjs/operators/filter';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { UPDATED_CONTENT_TITLE } from '../actions/ActionTypes';
import { receiveContent, requestedUpdateContentFailed, requestedUpdateContentSucceeded, requestUpdateContent } from '../actions/ContentActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(UPDATED_CONTENT_TITLE).pipe(filter(({
  payload: {
    title
  }
}) => !!title), mergeMap(({
  payload: {
    contentType,
    id,
    title
  }
}) => ContentClient.updateTitle(contentType, id, title).pipe(mergeMap(content => of(receiveContent(content), requestedUpdateContentSucceeded(contentType))), catchError(error => of(requestedUpdateContentFailed(error, contentType))), startWith(requestUpdateContent())))));